import {
    useGlobalUserData,
    useGlobalUserDataState,
} from '@/hooks/useGlobalUserData';
import { createContext } from 'react';

//暫定放冇save server & local storage, re-login game 就會 del data
export const GlobalUserDataContext = createContext(
    {} as useGlobalUserDataState
);

type GlobalDataProviderProps = {
    children: JSX.Element;
};

export const GlobalUserDataProvider = (props: GlobalDataProviderProps) => {
    const { children } = props;
    const globalData = useGlobalUserData();
    return (
        <GlobalUserDataContext.Provider value={globalData}>
            {children}
        </GlobalUserDataContext.Provider>
    );
};
